import React from 'react';

import Tooltip from '@mui/material/Tooltip';

import DynamicAvatar from './DynamicAvatar';

const tooltipSx = {tooltip: {className: '!text-base !text-main-normal !bg-background-normal !border !border-panels-normal !shadow-lg !rounded-input'}};

const UserAvatar = ({user, size = 24, fontSize = 10}) => {
    const name = [user.FirstName || user.Name, user.LastName].filter(Boolean).join(' ') || user.Email;
    return (
        <Tooltip title={name} placement="top" componentsProps={tooltipSx}>
            <div>
                <DynamicAvatar
                    user={{Name: user.FirstName || user.Name, LastName: user.LastName}}
                    imageSrc={user.UserIcon}
                    style={{width: size, height: size, fontSize}}
                />
            </div>
        </Tooltip>
    );
};

const AvatarRow = ({items = [], renderItem, maxDisplay = 3, size = 24, fontSize = 10, overlap = '-space-x-2'}) => {
    if (!items.length) return null;
    const displayed = items.slice(0, maxDisplay);
    const extraCount = items.length - maxDisplay;
    const defaultRender = (item) => <UserAvatar key={item._id || item} user={item} size={size} fontSize={fontSize} />;

    return (
        <div className={`flex items-center ${overlap}`}>
            {displayed.map(renderItem || defaultRender)}
            {extraCount > 0 && (
                <div
                    className="flex items-center justify-center rounded-full bg-panels-normal text-main-normal font-medium"
                    style={{width: size, height: size, fontSize}}
                >
                    +{extraCount}
                </div>
            )}
        </div>
    );
};

export {UserAvatar};
export default AvatarRow;
